import React, { useState } from 'react';
import swal from 'sweetalert';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const BooleanButtons = ({
  id,
  currentStatus,
  btnSize = 'xs',
  fontSize = 'xs',
  onStatusRefresh,
  functionToUpdateBe,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeStatus = (newStatus) => {
    swal({
      title: t('common.CONFIRMATION_NEEDED'),
      icon: 'warning',
      buttons: {
        cancel: {
          text: t('common.CANCEL'),
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: t('common.CONFIRM'),
          value: true,
          visible: true,
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willChange) => {
      if (willChange) {
        functionToUpdateBe(id, newStatus).then(() => {
          onStatusRefresh();
        });
      }
    });
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const composeButtons = () => {
    if (currentStatus === 'true') {
      return (
        <ButtonDropdown isOpen={isOpen} toggle={toggle}>
          <DropdownToggle caret size={btnSize} style={{ fontSize }} outline color="success">
            {t('common.TRUE')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => changeStatus('false')}>
              <b>{t('common.FALSE')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else if (currentStatus === 'false') {
      return (
        <ButtonDropdown isOpen={isOpen} toggle={toggle}>
          <DropdownToggle caret size={btnSize} style={{ fontSize }} outline color="inverse">
            {t('common.FALSE')}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => changeStatus('true')}>
              <b>{t('common.TRUE')}</b>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      );
    } else {
      return <div>Error: status not received</div>;
    }
  };

  return composeButtons();
};

export default BooleanButtons;
